<div class="content"> 
    <div class="content">
     <div class="container-fluid">
     <div class="row">
     <div class="col-lg-12 col-md-12 col-sm-12 common_title">
     <h2>MONTHLY CALCULATIONS - PERCENTAGE</h2>
     <!--<p>Monthly Calculation Percentage</p>-->
      <a [routerLink]="['/dashboard','Reportmanagement']" class="back_to"><i class="fa fa-chevron-left" aria-hidden="true"></i> Back</a>
     </div>
     </div>
     <div class="row">
      <div class="col-lg-2 col-sm-3 col-12 " style="margin-top: 11px;">
        <div class="form-group" >
        <form enctype="application/x-www-form-urlencoded" role="form" autocomplete="off" >
          <fieldset>
            <date-range-picker [options]="" [controlName]="'rightDateRange'" aria-readonly="true"></date-range-picker>
          </fieldset>
        </form>
        </div>
       </div>
     <div class="col-lg-2 col-md-3 col-sm-12">
        <div class="form-group multiple">
        <label for="Species Name">Farm Name</label>
        <select  name="farmname" id="farmname" class="form-control selectpicker myFakeClass" >
          <option *ngFor='let farmlist of getfarmsListData' [value]="farmlist.tnfr_id">{{farmlist.tnfr_name}}</option>
        </select>
        </div>
      </div>
      <div class="col-lg-2 col-md-3 col-sm-12">
          <div class="form-group">
          <label for="Species Name">Species Name</label>
          <select id="Speciesname" class="selectpicker form-control myFakeClass1" (change)="breedselectbyspecies($event)">
            <option *ngFor='let specieslist of speciesloaddata' [value]="specieslist.id">{{specieslist.name}}</option>
          </select>
          </div>
          </div>
          <div class="col-lg-2 col-md-3 col-sm-12">
            <div class="form-group">
            <label for="Breed Name">Breed Name</label>
            <select id="BreedName" class="selectpicker form-control myFakeClass2">
              <option *ngFor='let breedname of getspeciesvalue' [value]="breedname.id">{{breedname.name}}</option>
            </select>
            </div>
            </div>
            <div class="col-lg-2 col-sm-3 col-12" >
              <div class="form-group">
                 <label for="Breed Name">Age</label>
                 <select id="age" class="selectpicker form-control myFakeClass3" >
                  <option *ngFor='let age_data of get_age' [value]="age_data.tnag_id">{{age_data.tnag_name}}({{age_data.tnag_time_range}}) </option>
                </select>
              </div>
             </div>
             <div class="col-lg-1 col-sm-3 col-12">
              <div class="form-group">
                <label for="Breed Name"></label>
                 <span class="input-group-btn">
                     <button class="btn btn-primary search" type="button" (click)="get_datas()" ><span class="fa fa-search"></span> Search</button>
                 </span>
                </div>
                
          </div>
          <div class="col-lg-1 col-sm-3 col-12" style="margin-top: 18px;">
            <div class="form-group">
              <span class="input-group-btn">
                <button class="btn btn-primary" type="button" (click)="exportdata()" ><span class="fa fa-download"></span></button>
              </span>
           </div>

          </div>
     </div>
    <div class="row" id="contentToConvert">
    <h4 class="subhead">PERCENTAGE OF MORTALITY</h4>
    <div class="row percentofmortality">
        <div  class="col-lg-4 col-md-6 col-sm-12 stylefordiv">
           <div class="row" style="margin-top: 48px;">
              <div class="col-lg-5 col-md-5">
               <div>
             <p>Number of Animals Died</p>
             </div>
              </div>
              <div class="col-lg-2 col-md-2"><p class="slash">/</p></div>
              <div class="col-lg-5 col-md-5"> <div>
               <p>Total Number of Animals Handled</p>
               </div></div>
         </div>
         </div>
         <div  class="col-lg-4 col-md-6 col-sm-12 stylefordiv">
            <div class="row" style="margin-top: 48px;">
               <div class="col-lg-5 col-md-5 text-right">
                <div>
              <p style="font-size: 35px;">{{getData.died_count}}</p>
              </div>
               </div>
               <div class="col-lg-2 col-md-2"><p class="slash">/</p></div>
               <div class="col-lg-5 col-md-5 "> <div>
                <p style="font-size: 35px;">{{getData.animal_handled}}</p>
                </div></div>
          </div>
        </div>
        <div  class="col-lg-4 col-md-6 col-sm-12 " >
            <div class="col-lg-12 col-md-6 col-sm-12" >
          <h4 class="percentvaltopsize">Percentage Of Mortality</h4>
          </div>
          <div class="col-lg-12 col-md-6 col-sm-12" style="background-color: #3f3688;">
        <h4 class="percentval1">{{getData.mortality_percentage}} %</h4>
        </div>
        </div>

    </div>
    <h4 class="subhead">EQUIVALENT ANIMAL DEATH RATE(EADR)</h4>
    <div class="row percentofmortality">
        <div  class="col-lg-4 col-md-6 col-sm-12 stylefordiv">
         <div class="row" style="margin-top: 27px;">
            <div class="col-lg-5 col-md-5">
             <div>
           <p>Number of Animals Died</p><div class="devicer"></div><p>Total Number of Animals Days</p>
           </div>
            </div>
            <div class="col-lg-2 col-md-2" style="margin-top: 20px;"><i class="fa fa-times" aria-hidden="true"></i></div>
            <div class="col-lg-5 col-md-5" style="margin-top: 32px;
            font-size: 35px;"> <div>
               <span>1000</span>
             </div></div>
       </div>
         </div>
         <div  class="col-lg-4 col-md-6 col-sm-12 stylefordiv">
            <div class="row" style="margin-top: 27px;">
               <div class="col-lg-5 col-md-5 text-center">
                <div>
              <p style="padding: 10px; font-size: 26px;">{{getData.died_count}}</p><div class="devicer"></div><p style="padding: 10px; font-size: 26px;">{{closing_total}}</p>
              </div>
               </div>
               <div class="col-lg-2 col-md-2" style="margin-top: 20px;"><i class="fa fa-times" aria-hidden="true"></i></div>
               <div class="col-lg-5 col-md-5" style="margin-top: 32px;
               font-size: 35px;"> <div>
                  <span>1000</span>
                </div></div>
          </div>
        </div>
        <div  class="col-lg-4 col-md-6 col-sm-12 " >
            <div class="col-lg-12 col-md-6 col-sm-12" >
          <h4 class="percentvaltopsize">EADR</h4>
          </div>
          <div class="col-lg-12 col-md-6 col-sm-12" style="background-color: #3f3688;">
        <h4 class="percentval1">{{percent}} </h4>
        </div>
        </div>

    </div>
     <div class="row">

        <div  class="col-lg-4 col-md-6 col-sm-6">
          <a><div class="card card-stats reports"  style="cursor:pointer">
               <div class="card-header reports card-header-warning card-header-icon">
                <p class="card-category reports">Opening balance at start of month</p>
               </div>
               <div class="card-footer">
                <h4>{{getData.opening_count}}</h4>
                   </div>
           </div></a>
         </div>
         <div  class="col-lg-4 col-md-6 col-sm-6">
            <a><div class="card card-stats reports"  style="cursor:pointer">
                 <div class="card-header reports card-header-warning card-header-icon">
                  <p class="card-category reports">Addition</p>
                 </div>
                 <div class="card-footer">
                    <h4>{{getData.addition_value}}</h4>
                       </div>
             </div></a>
           </div>
           <div  class="col-lg-4 col-md-6 col-sm-6">
            <a><div class="card card-stats reports"  style="cursor:pointer">
                 <div class="card-header reports card-header-warning card-header-icon">
                  <p class="card-category reports">Total number of animals handled</p>
               
                 </div>
                 <div class="card-footer">
                    <h4>{{getData.animal_handled}}</h4>
                       </div>
             </div></a>
           </div>
           <div  class="col-lg-4 col-md-6 col-sm-6">
            <a><div class="card card-stats reports"  style="cursor:pointer">
                 <div class="card-header reports card-header-warning card-header-icon">
                  <p class="card-category reports">Deletion / Transfer</p>
       
                 </div>
                 <div class="card-footer">
                    <h4>{{getData.delete_count}}</h4>
                       </div>
             </div></a>
           </div>
           <div  class="col-lg-4 col-md-6 col-sm-6">
            <a><div class="card card-stats reports"  style="cursor:pointer">
                 <div class="card-header reports card-header-warning card-header-icon">
                  <p class="card-category reports">No.Died during selected interval date</p>
                 </div>
                 <div class="card-footer">
                    <h4>{{getData.died_count}}</h4>
                       </div>
             </div></a>
           </div>
           <div  class="col-lg-4 col-md-6 col-sm-6">
            <a><div class="card card-stats reports"  style="cursor:pointer">
                 <div class="card-header reports card-header-warning card-header-icon">
                  <p class="card-category reports">Closing balance at end of month</p>
                 </div>
                 <div class="card-footer">
                    <h4>{{getData.closing_balance}}</h4>
                       </div>
             </div></a>
           </div>
           <div  class="col-lg-4 col-md-6 col-sm-6">
            <a><div class="card card-stats reports"  style="cursor:pointer">
                 <div class="card-header reports card-header-warning card-header-icon">
                  <p class="card-category reports">Percentage of mortality during selected interval date</p>
                 </div>
                 <div class="card-footer">
                    <h4>{{getData.mortality_percentage}} %</h4>
                       </div>
             </div></a>
           </div>
           <div  class="col-lg-4 col-md-6 col-sm-6">
            <a><div class="card card-stats reports"  style="cursor:pointer">
                 <div class="card-header reports card-header-warning card-header-icon">
                  <p class="card-category reports">Animal days for selected interval date</p>
                 </div>
                 <div class="card-footer">
                    <h4 id="animal_days">{{closing_total}}</h4>
                       </div>
             </div></a>
           </div>
           <div  class="col-lg-4 col-md-6 col-sm-6">
            <a><div class="card card-stats reports"  style="cursor:pointer">
                 <div class="card-header reports card-header-warning card-header-icon">
                  <p class="card-category reports">EADR During selected interval date</p>
                 </div>
                 <div class="card-footer">
                    <h4>{{percent}}  </h4>
                       </div>
             </div></a>
           </div>
       </div>
       </div>
   </div>
 </div>
</div>
